import { CropYearDetailResponseTimeOfYearEnum } from "api";

export const cropYearIsInPreHarvest = (
  cropYearTimeOfYear?: CropYearDetailResponseTimeOfYearEnum
) => cropYearTimeOfYear === CropYearDetailResponseTimeOfYearEnum.PreHarvest;
